import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { channelItemShape } from '../helpers/propTypeShapes';

import PastBroadcasts from '../components/PastBroadcasts';

export default function Recordings({
  accountId,
  channels,
  checkAuthorization,
  componentReady,
  getScreenOrientation,
  loadBroadcasts,
  reAuth,
  trackEvent,
  loadChannels,
}) {
  useEffect(() => {
    checkAuthorization('recordings');
  }, [checkAuthorization, accountId]);

  useEffect(() => {
    if (accountId && channels?.length === 0) {
      loadChannels();
    }
  }, [loadChannels, channels, accountId]);

  if (componentReady && channels.length > 0) {
    return (
      <div className="content-container full-width-desktop">
        <PastBroadcasts
          key={accountId}
          getScreenOrientation={getScreenOrientation}
          loadBroadcasts={loadBroadcasts}
          reAuth={reAuth}
          trackEvent={trackEvent}
        />
      </div>
    );
  }
  return <div />;
}

Recordings.propTypes = {
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  channels: PropTypes.arrayOf(channelItemShape).isRequired,
  checkAuthorization: PropTypes.func.isRequired,
  componentReady: PropTypes.bool.isRequired,
  getScreenOrientation: PropTypes.func.isRequired,
  loadBroadcasts: PropTypes.func.isRequired,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  loadChannels: PropTypes.func.isRequired,
};
